import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { CrudService, ConfigServerService, CustomHttp, Crud } from '../../../core';
import { TituloReceber } from '../titulo-receber';
import { TituloReceberSearchAsync } from './titulo-receber-search-async';
import { Filter } from '../../../models';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberCrudHttpService implements Crud<TituloReceber> {
    resource = 'tituloreceber';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os títulos a receber cadastrados */
    search(): Observable<TituloReceber[]> {
        return this.crudService.search<TituloReceber>(this.resource);
    }

    /** Pesquisa todos os títulos a receber cadastrados aplicando o filtro*/
    searchWithFilter(filter: Filter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<TituloReceberSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable.toString())
                            .append('offset', offset.toString())
                            .append('limit', limit.toString())
                            .append('orderBy', orderBy.toString())
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TituloReceberSearchAsync>(this.pathApi, {params});
    }

    /** Procura um único título a receber através do seu ID */
    find(id: number): Observable<TituloReceber> {
        return this.crudService.find<TituloReceber>(this.resource, id);
    }

    /** Carrega um único título a receber através do seu ID */
    load(id: number): Observable<TituloReceber> {
        return this.crudService.load<TituloReceber>(this.resource, id);
    }

    /** Insere um novo título a receber */
    insert(entity: TituloReceber): Observable<TituloReceber> {
        return this.crudService.insert<TituloReceber>(this.resource, entity);
    }

    /** Altera um título a receber existente */
    update(entity: TituloReceber): Observable<TituloReceber> {
        return this.crudService.update<TituloReceber>(this.resource, entity);
    }

    /** Exclui um título a receber através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
